<template>
    <div id="dealerStatistic">
        <div v-if="userInfo.type_id === 1" class="mb-5 mr-5 ag-grid-table-actions-left" style="display: flex">
            <div class="con-select select-large" style="width: auto">
                <div class="input-select-con">
                    <select v-model="country_id" @change="refresh" class="input-select vs-select--input">
                        <option :key="index" :value="item.id" v-for="(item,index) in countries">{{ item.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <vx-card class="text-center">
            <h2 class="mb-3" style="color:#2f6eef">{{ $t('Quarter') }}: <span id="quarter" style="color:#8aabf1"></span></h2>
            <h3 class="mb-3" style="color:#2f6eef">{{ $t('Months') }}: <span id="months" style="color:#8aabf1"></span></h3>
        </vx-card>

        <vx-card class="text-center mt-6" v-if="userInfo.type_id === 3 || userInfo.type_id === 4">
            <h2 class="mb-3" style="color:#2f6eef">{{ $t('TargetProgress') }} : <span style="font-size: 21px;color:#8aabf1"><span id="compPercent">0</span>% {{ $t('toComplete') }}</span></h2>
            <h3 class="mb-3" style="color:#8aabf1">{{ $t('Sum') }} : <span id="sum">0</span> $</h3>
            <div class="vx-row">
                <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-3/12 xl:w-3/12 sm:hidden md:hidden lg:block xl:block mb-base"></div>
                <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-6/12 xl:w-6/12 mb-base">
                    <div id="progressBar">
                        <span class="pbDots" id="d_t0">
                            <span>0 $</span>
                        </span>
                        <span class="pbDots" id="d_t1">
                            <span>0 $</span>
                        </span>
                        <span class="pbDots" id="d_t2">
                            <span>0 $</span>
                        </span>
                        <div id="progress"></div>
                    </div>
                </div>
                <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-3/12 xl:w-3/12 sm:hidden md:hidden lg:block xl:bloc mb-base"></div>
            </div>
        </vx-card>

        <vx-card class="text-center mb-6 mt-6">
            <h2 class="mb-3" style="color:#2f6eef">{{ $t('BestSeller') }}</h2>
            <div class="vx-row">
                <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/2 xl:w-1/2 mb-base">
                    <h3 v-if="userInfo.type_id === 1 || userInfo.type_id === 2">{{ $t('DealerName') }}</h3>
                    <h3 v-else>{{ $t('group') }}</h3>
                    <div id="bg_title"></div>
                    <div id="bg_sum"></div>
                </div>
                <div class="vx-col w-full sm:w-1/1 md:w-1/1 lg:w-1/2 xl:w-1/2 mb-base">
                    <h3>{{ $t('user') }}</h3>
                    <div id="bu_name"></div>
                    <div id="bu_sum"></div>
                </div>
            </div>
        </vx-card>

        <vx-card class="text-center">
            <h2 class="mb-3" style="color:#2f6eef">{{ $t('Top5Products') }}</h2>
            <e-charts :options="pie" ref="pie" auto-resize />
        </vx-card>

    </div>
</template>

<script>
    import ECharts from 'vue-echarts/components/ECharts'
    import 'echarts/lib/component/tooltip'
    import 'echarts/lib/component/legend'
    import 'echarts/lib/chart/pie'

    export default {
        components: {
            ECharts
        },
        data() {
            return {
                userInfo: window.userInfo,
                countries: [],
                country_id: 0,
                stats : [],
                pie: {
                    tooltip: {
                        trigger: 'item',
                        formatter: 'Count : {c}' /*  = ({d}$) */
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },
                    series: [{
                        name: 'Access source',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: [],
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                },
            }
        },

        watch: {

        },

        created() {
            this.$vs.loading();
            const thisIns = this;

            if (this.userInfo.type_id === 1) {
                axios.get(apiUrl + '/countries/getList?token=' + token)
                    .then(function (response) {

                        let data = response.data;
                        if (data.code === 200) {
                            thisIns.countries = data.data;
                            thisIns.countries.unshift({
                                id: 0,
                                name: "Global"
                            });
                            //thisIns.country_id = data.data[0].id;
                            thisIns.refresh();
                        } else {
                            if (data.code === 401) {
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text: data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                    });
            }
            else{
                thisIns.country_id = this.userInfo.country_id;
                thisIns.refresh();
            }
        },
        methods: {
            refresh(){
                const thisIns = this;

                axios.get(apiUrl+'/statistic/quarter?country_id='+this.country_id+'&token='+token)
                    .then(function (response) {

                        let data = response.data;
                        if(data.code === 200){
                            thisIns.stats = data.data;

                            document.getElementById('quarter').innerHTML = thisIns.stats.quarter.num;
                            document.getElementById('months').innerHTML = thisIns.stats.quarter.months;

                            let target = thisIns.stats.target;
                            let t1 = target.t1;
                            let t2 = target.t2;
                            let sum = target.sum;
                            let percent = sum * 100 / t2;
                            if (percent < 0) percent = 0;
                            else if (percent > 100) percent = 100;

                            if (thisIns.userInfo.type_id === 3) {
                                document.getElementById('sum').innerHTML = sum;
                                document.getElementById('progress').style.width = percent + '%';
                                document.getElementById('compPercent').innerHTML = Math.round(percent);
                                document.getElementById('d_t1').style.left = (t1 * 100 / t2) + '%';
                                document.getElementById('d_t1').childNodes[0].innerHTML = t1 + ' $';
                                document.getElementById('d_t2').childNodes[0].innerHTML = t2 + ' $';
                            }

                            let best = thisIns.stats.best;
                            if (thisIns.userInfo.type_id === 3) {
                                document.getElementById('bg_title').innerHTML = best.group.title;
                                document.getElementById('bg_sum').innerHTML = best.group.sum + ' $';
                            }else{
                                document.getElementById('bg_title').innerHTML = best.dealer.name;
                                document.getElementById('bg_sum').innerHTML = best.dealer.sum + ' $';
                            }
                            document.getElementById('bu_name').innerHTML = best.user.name;
                            document.getElementById('bu_sum').innerHTML = best.user.sum+' $';


                            let products = thisIns.stats.top.products;
                            thisIns.pie.legend.data = [];
                            thisIns.pie.series.data = [];
                            if (products.length > 0){
                                for (let i = 0; i < products.length; i++) {
                                    thisIns.pie.legend.data.push(products[i].title);
                                    thisIns.pie.series[0].data.push({
                                        name : products[i].title,
                                        value : products[i].count,
                                    });
                                }
                            }

                        }else{
                            if (data.code === 401){
                                window.logout();
                            }
                            thisIns.$vs.notify({
                                title: 'Error',
                                text:  data.message,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle'
                            });
                        }
                        thisIns.$vs.loading.close();
                    });
            }
        },
    }

</script>


<style lang="scss" scoped>
    #progressBar{
        width: 100%;
        height: 20px;
        border-radius: 20px;
        background: #c0d2f1;
        position: relative;

        .pbDots{
            background: #ffffff;
            width: 8px;
            height: 8px;
            top: 6px;
            display: inline-block;
            position: absolute;
            z-index: 2;
            border-radius: 50%;

            span{
                white-space: nowrap;
                font-size: 12px;
                font-weight: 500;
                color: #a09e9e;
                position: absolute;
                top: 14px;
                left: -13px;
            }
        }

        #d_t0{
            left: 5px;
            span{
                left: -5px;
            }
        }
        #d_t1{
            left: 38%;
            margin-left: -4px;
        }
        #d_t2{
            right: 5px;
        }

        #progress{
            width: 0%;
            height: 20px;
            border-radius: 20px;
            background: #2f6fed;
            position: absolute;
        }
    }

    #bg_title, #bu_name{
        font-weight: 600;
    }
    #bg_sum, #bu_sum{
        font-weight: 500;
    }
</style>
